var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "500", persistent: "", "content-class": "mainModal" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "div",
                    { staticClass: "float" },
                    [
                      _vm.editable
                        ? _c(
                            "v-fab-transition",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "floatButton",
                                  attrs: {
                                    color: "green",
                                    width: "14px",
                                    height: "14px",
                                    plain: "",
                                    text: "",
                                    absolute: "",
                                    top: "",
                                    right: "",
                                    fab: ""
                                  }
                                },
                                [_c("v-icon", [_vm._v("mdi-pencil")])],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-textarea",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "textArea",
                              attrs: {
                                height: "50px",
                                solo: "",
                                "hide-details": "true",
                                readonly: "",
                                value: _vm.resume,
                                "no-resize": ""
                              }
                            },
                            "v-textarea",
                            attrs,
                            false
                          ),
                          on
                        )
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "cardModal", attrs: { elevation: "0" } },
            [
              _c(
                "div",
                { staticClass: "input-wrapper textAreaModal" },
                [
                  _c("h2", { staticClass: "titleSection" }, [
                    _vm._v(_vm._s(_vm.title))
                  ]),
                  _vm._v(" "),
                  _vm.editable
                    ? _c("div", [
                        _c("p", [
                          _vm._v("Lo que escribas en "),
                          _c("b", [_vm._v(_vm._s(_vm.title))]),
                          _vm._v(" se propagará a todos los alumnos.")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-textarea", {
                    attrs: {
                      outlined: "",
                      label: "Mensaje a: " + _vm.student,
                      counter: "250",
                      "auto-grow": "",
                      rows: "3"
                    },
                    model: {
                      value: _vm.inputVal,
                      callback: function($$v) {
                        _vm.inputVal = $$v
                      },
                      expression: "inputVal"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex align-center justify-space-between" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", depressed: "" },
                      on: {
                        click: function($event) {
                          return _vm.clear()
                        }
                      }
                    },
                    [_vm._v("\n            Cancelar\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success", depressed: "" },
                      on: {
                        click: function($event) {
                          return _vm.propagateChange()
                        }
                      }
                    },
                    [_vm._v("\n            Aceptar\n          ")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-305b8182", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-305b8182","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/diaryElements/TextAreaInputModal.vue
// module id = 271
// module chunks = 1